module.exports = __webpack_public_path__ + "img/php-banner.71e41e3d.webp";